/* tslint:disable */
/* eslint-disable */
export enum UserAccountRegistrationConflictType {
  AccountDisabled = 'account_disabled',
  EmailAlreadyRegistered = 'email_already_registered',
  ExternalAccountAlreadyRegistered = 'external_account_already_registered',
  ReferenceFieldIsRequired = 'reference_field_is_required',
  ReferenceFieldWasNotAccepted = 'reference_field_was_not_accepted'
}
